export const CanvasData = {
    "1": [],
    "2": [],
    "3": []
}